import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";
import { generatePaginationLinks } from "./generate-pages";
import { PaginatorProps } from "@/common/types";

const Paginator = ({
  currentPage,
  totalPages,
  showPrevious,
  showNext,
  onPageChange,
}: PaginatorProps) => {
  return (
    <Pagination className="m-2 justify-start">
      <PaginationContent>
        {totalPages > 1 && (
          <PaginationItem>
            <PaginationPrevious
              className={!showPrevious ? "opacity-50" : ""}
              onClick={(e) => {
                if (showPrevious) {
                  onPageChange(currentPage - 1);
                } else {
                  e.preventDefault();
                }
              }}
            />
          </PaginationItem>
        )}
        {(showPrevious || showNext) &&
          generatePaginationLinks(currentPage, totalPages, onPageChange)}
        {totalPages > 1 && (
          <PaginationItem>
            <PaginationNext
              className={!showNext ? "opacity-50" : ""}
              onClick={(e) => {
                if (showNext) {
                  onPageChange(currentPage + 1);
                } else {
                  e.preventDefault();
                }
              }}
            />
          </PaginationItem>
        )}
      </PaginationContent>
    </Pagination>
  );
};

export default Paginator;
